import React from "react";
import "./Vision.css";

function Vision() {
  return (
    <div className="vision">
      <div className="ourvision">
        <div className="visionheading">OUR VISION</div>
        <div className="visioncontent">
          <div className="visionm1">
            To create a world where <span className="visionm11" >fitness and philanthropy go hand in hand</span>,
            empowering individuals to lead healthier lives while making a
            positive impact on the world.
          </div>
          <div className="visionm2">
            <div className="visionm21">
              Through Impact app, we aim to inspire and reward users for their
              physical activities, by connecting their steps to charitable
              causes, and to discounts and giveaways offered by top global
              brands. Together, we will create a healthier, more active, and
              more giving global community, one step at a time.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Vision;
